export const LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE = 31;
export const ACCOUNT_PICKER_LAYOUT = 'ACCOUNT_PICKER_LAYOUT';
